import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import { AiFillGithub } from "react-icons/ai";
import { BiMenu } from "react-icons/bi";
import { useSidebarContext } from "../sidebarReducer/sidebar_reducer";

function Navbar() {
  const { openSidebar } = useSidebarContext();
  return (
    <Wrapper id="navbar">
      <main className="nav-center">
        <h1 className="alforoan">Alforoan</h1>

        <ul className="page-link-list">
          <li className="home">
            <Link to="home" smooth={true}>
              Home
            </Link>
          </li>
          <li>
            <Link to="about" smooth={true}>
              About
            </Link>
          </li>
          <li className="projects">
            <Link to="projects" smooth={true}>
              Projects
            </Link>
          </li>
        </ul>
        <button type="button" className="github-icon">
          <a
            target="_blank"
            rel="noopener nonreferrer"
            href="https://github.com/Alforoan"
          >
            <AiFillGithub onClick={openSidebar} />
          </a>
        </button>
        <button type="button" className="nav-toggle" onClick={openSidebar}>
          <BiMenu />
        </button>
      </main>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  font-size: 2rem;
  display: flex;
  width: 100vw;
  padding-top: 1rem;
  padding-bottom: 1rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  .nav-center {
    max-width: 1100px;
    width: 90vw;
    display: flex;
    justify-content: space-between;
    margin: auto;
    align-items: center;
    align-content: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .alforoan {
    font-size: 2rem;
    border: none;
    background: white;
  }
  .underline {
    border: 1px solid black;
  }
  .page-link-list {
    display: flex;
    list-style: none;
    cursor: pointer;
  }
  .page-link-list a {
    text-decoration: none;
    padding-right: 2rem;
  }

  .github-icon {
    background: none;
    border: none;
    font-size: 2rem;
    cursor: pointer;
    color: black;
  }
  .github-icon a:visited {
    color: black;
  }
  .projects {
    padding-right: 1rem;
  }

  .nav-toggle {
    background: transparent;
    border: transparent;

    cursor: pointer;
    svg {
      font-size: 2rem;
    }
  }
  .page-link-list a:hover {
    color: red;
    transition: all 0.3s linear;
  }
  @media screen and (max-width: 990px) {
    .page-link-list {
      display: none;
    }
    .github-icon {
      display: none;
    }
  }
  @media screen and (min-width: 990px) {
    .nav-toggle {
      display: none;
    }
  }
`;

export default Navbar;
